import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta13 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-13/utils-consultaSeguimentoPergunta13'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta13 } from './converter-HistoricoMchatPergunta13'

interface HistoricoMChatRfPergunta13Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta13 = (props: Readonly<HistoricoMChatRfPergunta13Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta13(aplicacoes)
  if (converted == null) return null

  const { header, andaSemApoio, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta13(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='13'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={undefined}
      />
      {andaSemApoio && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[andaSemApoio]} />}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
